export default __webpack_public_path__ + "static/media/ram.c1a2ecad.webp";